// extracted by mini-css-extract-plugin
module.exports = {"writeUsWrap":"write-us-block_writeUsWrap__YjHlR","title":"write-us-block_title__lVUUD"};